import React, { useState, Component } from "react";
import Switch from "react-switch";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Link, NavLink } from "react-router-dom";
import './Profile.css';
import Error from "../Error/Error";
import Updated from "../Messages/Updated";
import SignupDataService from "../../services/signup.service";
var bcrypt = require('bcryptjs');


class Profile extends React.Component{


  buildOptions() {
    var arr = [];
    for (let i = 18; i <= 99; i++) {
        arr.push(<option key={i} value={i}>{i}</option>)
    }

    return arr; 
}


  constructor(props) {
    const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
    let userid = 0;
    if(isLoggedIn)
    {
    userid = window.localStorage.getItem("userid");

    }

    super(props);
    this.state = {
      name: '',
      email: '',
      age: 0,
      gender: 0,
      preference: 0,
      stage: 0,
      userid: userid,
      active: false,
      activeLabel: 'Inactive'
    };
  }

 
 

  onNameChange = (event) => {
    this.setState({name: event.target.value})
  }


  onGenderChange = (event) => {
  
    this.setState({gender: event.target.value})
  }
  onPreferenceChange= (event) => {
  
    this.setState({preference: event.target.value})
  }

  onAgeChange = (event) => {
   
    this.setState({age: event.target.value})
  }

  validateForm = () => {
    return this.state.email.length > 0  && this.state.name.length > 0 && this.state.gender > 0 && this.state.age > 0 && this.state.email.includes('georgetown.edu');
  }

  handleChange = (checked) =>
  {

    this.setState({active : checked});
    if(checked == true)
        {
          this.setState({activeLabel: 'Active'})
        }
        else
        {
          this.setState({activeLabel: 'Inactive'})
        }
  }

   handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({stage: 0});

    if(this.state.userid == 0)
    return;

    var data = {
      name: this.state.name,
      age: parseInt(this.state.age),
      gender: parseInt(this.state.gender),
      preference: parseInt(this.state.preference),
      active: this.state.active
    };


    await SignupDataService.update(this.state.userid, data)
    .then(response => {
      if(response.data.message == 1)
      {
        //display updated comppnent
        this.setState({stage: 1});
      }
      else
      {
        //display unable to updated component
        this.setState({stage: 2});
      }
    
    })
    .catch(e => {
      console.log(e);
    });


  }

 

  componentDidMount() {

    SignupDataService.get(parseInt(this.state.userid))
    .then(response => {
      if(response.data != '')
      {
        if(response.data.active)
        {
          this.setState({activeLabel: 'Active'})
        }
        else
        {
          this.setState({activeLabel: 'Inactive'})
        }
      this.setState({
        name: response.data.name,
        email: response.data.email,
        age: response.data.age,
        gender: response.data.gender,
        preference: response.data.preference,
        active: response.data.active

      });

    }

    })
    .catch(e => {
      console.log(e);
    });
  }

  render(){

  return (
    <div  className="container col-md-6">
       <div className="col-md-12 front-text">
      {this.state.stage == 1 ? <Updated Color={'accept-color'} Message={'Profile Updated.'}/> : ''}
      {this.state.stage == 2 ? <Error Message={'Unable to update your Profile.'}/> : ''}
      {this.state.stage == 3 ? <Error Message={'System error. Please contact help desk.'}/> : ''}
      </div>
  <span className="span"><b>Basic Profile</b></span>
      <Form onSubmit={this.handleSubmit}>
      <Form.Group size="lg" controlId="name">
          <Form.Label>Name</Form.Label>
          <Form.Control
            autoFocus maxLength="75" placeholder="Introduce yourself"
            type="text"
            value={this.state.name}
            onChange={this.onNameChange.bind(this)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control  disabled={true} maxLength="75"
            placeholder="Your Georgetown email"
            type="email"
            value={this.state.email}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="age">
          <Form.Label>Age</Form.Label>
          <Form.Control value={this.state.age} as="select" onChange={this.onAgeChange.bind(this)}>
           {this.buildOptions()}
        </Form.Control>
        </Form.Group>
        <Form.Group size="lg" controlId="gender">
          <Form.Label>Gender</Form.Label>
          <Form.Control value={this.state.gender} as="select" onChange={this.onGenderChange.bind(this)}>
           <option value="1">Male</option>
           <option value="2">Female</option>
    </Form.Control>
        </Form.Group>
        <Form.Group size="lg" controlId="gender">
          <Form.Label>Preference</Form.Label>
          <Form.Control value={this.state.preference} as="select" onChange={this.onPreferenceChange.bind(this)}>
           <option value="1">Male</option>
           <option value="2">Female</option>
           <option value="3">Everyone</option>
    </Form.Control>

    <label>
        <span>{this.state.activeLabel}</span>*
        <Switch onChange={this.handleChange} checked={this.state.active} />
      </label><hr/>
      <span className="inactive">Inactive accounts are not searchable</span>
        </Form.Group>
        <Button style={{cursor:'pointer'}} block size="lg" type="submit" disabled={!this.validateForm()}>
          Submit 
        </Button>
        <Link  to="/home"><img width="75" src="home.png" alt="go home" /></Link>
      </Form>
      <NavLink  to="/deleteprofile">Delete Profile</NavLink>
    </div>
  );
    

  }

}

export default Profile;